module.exports = __webpack_public_path__ + "img/Demon_04.be0f4e15.png";